import { render } from "./NewDayCard.vue?vue&type=template&id=692cdfde"
import script from "./NewDayCard.vue?vue&type=script&lang=js"
export * from "./NewDayCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__